<template>
    <div ref="slide" class="slide">
        <slot></slot>
    </div>
</template>
<script type="es6">
var _isIphonex = (function () {
    var ratio = window.devicePixelRatio || 1;
    var screen = {
        width: window.screen.width * ratio,
        height: window.screen.height * ratio
    };
    return function () {
        return /iphone/gi.test(navigator.userAgent) && (screen.height >= 2436);
    };
})()();
export default {
    name: 'PageSwiper',
    props: {
        height: Number,
        page: Number,
        callback: Function
    },
    data: () => {
        return {
            pre_page: 1
        };
    },
    updated: function () {
        var self = this;
        if (self.page != 1 && self.pre_page != self.page) {
            var start = (self.page - 2) * self.height;
            var end = (self.page - 1) * self.height;
            var animate_time = 200;

            if (_isIphonex) {
                animate_time = 100;
            }

            var dis = self.height * 10 / animate_time;
            var timer = setInterval(function () {
                if (start < end) {
                    start = start + dis;
                    if (start > end) {
                        start = end;
                    }
                    self.$refs.slide.style.top = '-' + start + 'px';
                } else {
                    clearInterval(timer);
                    self.callback();
                }
            }, 10);
        }
        self.pre_page = self.page;
    }
};
</script>
<style>
.slide {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
}
</style>
